import * as Sentry from '@sentry/react';

import { toPdfViewerSentryEvent } from '@liscio/common';
import type { PdfViewerErrorHandler } from '@liscio/ui';

/** Sends shared viewer failures to the legacy app's Sentry, without file data. */
export const reportPdfViewerError: PdfViewerErrorHandler = (kind, failure) => {
  const { error, context } = toPdfViewerSentryEvent(kind, failure);
  Sentry.captureException(error, context);
};
